module.exports = __webpack_public_path__ + "media/src/images/removeIcon-d35db8dcd20029d61f1041e8925addf7.png";